import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends FeaturesBaseComponent implements OnInit {

  constructor() {
    super();
    
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }

}
